import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
    
    </footer>
  );
}

export default Footer;
